export async function storeValue(key, value) {
  return localStorage.setItem(key, value);
}
